import { ModelField, ModelGroup, ModelItem } from '../model-item';
import { IModelHandler, ModelProcessor } from '../processor/model-processor';

export class ModelItemAccessor implements IModelHandler {
  modelItemPaths: { [path: string]: ModelItem } = {};

  constructor(public model: ModelGroup) {
    new ModelProcessor(this.model, this).process();
  }

  processField(item: ModelField, level: number, index: number): void {
    this.modelItemPaths[item.path] = item;
  }

  processGroup(item: ModelGroup, level: number, index: number): void {
    this.modelItemPaths[item.path] = item;
  }

  getModelItem(path: string): ModelItem {
    return this.modelItemPaths[path];
  }
}
